import React, { useContext, useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { i18nContext } from '@/components/pages/assessments/context/i18n.context';
import { displayContext } from '@/components/pages/assessments/context/display.context';

const QuestionLocation = ({ question, answer, setAnswer, setQuestionComplete, previewOnly = false }) => {
  const pattern = '^\\d{5}([\\-]\\d{4})?$';
  const checkValid = (inputValue, checkPattern) => {
    let regExp = new RegExp(checkPattern);
    if (regExp.test(inputValue)) {
      return true;
    } else {
      return false;
    }
  };
  const { t } = useContext(i18nContext);
  const { css } = useContext(displayContext);
  const [value, setValue] = useState(answer || '');
  const required = !!question.required;
  const [valid, setValid] = useState(checkValid(value, pattern));

  useEffect(() => {
    if (!previewOnly) {
      setQuestionComplete((!required && trim(value) === '') || (value !== null && value !== undefined && value !== '' && valid));
      setAnswer(value);
    }
  }, [value, valid, previewOnly]);

  return (
    <div className={`question-input question-location ${css('question-location')} ${css('question-location-' + question.value_subtype)}`}>
      {question.value_subtype === 'zip_code' && (
        <Form.Group>
          <Form.Control
            onChange={(e) => {
              if (!previewOnly) {
                setValue(e.target.value);
              }
            }}
            value={value}
            type="text"
            placeholder={question.helper_text}
            maxlength="10"
            pattern={pattern}
            onKeyPress={(e) => {
              if (previewOnly) {
                e.preventDefault();
                return;
              }
              if (e.key && isNaN(parseInt(e.key)) && e.key !== '-') {
                e.preventDefault();
              }
            }}
            onKeyUp={(e) => {
              if (!previewOnly) {
                setValid(checkValid(e.target.value, e.target.pattern));
              }
            }}
            isInvalid={!valid && value !== ''}
            isValid={valid}
            disabled={previewOnly}
            readOnly={previewOnly}
          />
          <label>{question.helper_text}</label>
          <Form.Control.Feedback type="invalid">{t('Please enter a 5-digit zip code (ex: 90001)')}</Form.Control.Feedback>
        </Form.Group>
      )}
    </div>
  );
};

export default QuestionLocation;
